export default __webpack_public_path__ + "static/media/donation.b54be447.svg";